module.exports = __webpack_public_path__ + "img/6.cccd1f85.png";